import React from 'react'
import styled from 'styled-components'
import { WishlistButton } from '../../../Common'
import { useProductState } from '@sentecacommerce-theme/lib'

export const FavoritesButton = () => {
  const { selectedVariant, metaData } = useProductState()

  return (
    <FavoriteButtonContainer>
      <WishlistButton
        productId={metaData._id as string}
        variantId={selectedVariant?._id as string}
      />
    </FavoriteButtonContainer>
  )
}

const FavoriteButtonContainer = styled.div`
  & button {
    padding: 0 !important;
    display: flex !important;
    align-items: center;
    justify-content: center;
    width: 4.4rem;
    height: 4.4rem;
    border-radius: 50%;
    border: 0.1rem solid ${({ theme }) => theme.palette.silverTree};

    &:hover {
      opacity: 0.6;
    }
  }

  & svg {
    width: 3rem;
  }
`
